import http from "./http-service"
import store from "@/store"
import cloneObject from "@/utils/clone-object"

export default class AppService {

  constructor(data) {

    if (data && data.path)
      this.path = data.path
      
    this.http = http
    this.store = store
    this.cloneObject = cloneObject
  }

  findAll(options) {

    let query = []
    let url = this.path

    if (options && options.attributes)
      query.push("attributes=" + options.attributes.toString())

    if (options && options.order)  
      query.push("order=" + options.order)

    if (options && options.sort)  
      query.push("sort=" + options.sort)
      
    if (options && options.orderModel)  
      query.push("orderModel=" + options.orderModel)  

    if (options && options.orderModelAlias)  
      query.push("orderModelAlias=" + options.orderModelAlias)    

    if (options && options.search)  
      query.push("search=" + options.search)  

    if (options && options.limit)  
      query.push("limit=" + options.limit)

    if (options && options.offset)  
      query.push("offset=" + options.offset)  

    for (let index = 0; index < query.length; index++) {
      if (index == 0) {
        url += "?"
      } else {
        url += "&"
      }
      url += query[index]
    }

    return this.http.get(url).then((response) => {

      if (this.onFindAll)
        this.onFindAll(response)

      return response
    })
  }

  findById(id) {
    return this.http.get(`${this.path}/${id}`)
  }

  create(entity) {
    return this.http.post(this.path, entity)
  }

  update(entity) {
    return this.http.put(`${this.path}/${entity.id}`, entity)
  }

  canRemove(entity) {
    return this.http.get(`${this.path}/${entity.id}/can-remove`)
  }

  remove(entity) {
    return this.http.delete(`${this.path}/${entity.id}`)
  }
}